import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {QualitaService} from '../../../_services/qualita.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {CqCicloControllo} from '../../../_models/CqCicloControllo';
import {ControlloQualita} from '../../../_models/ControlloQualita';
import {SaveMessage} from '../../../_helpers/save-message';
import {CqSchede} from '../../../_models/CqSchede';
import {CqCaratteristica} from '../../../_models/CqCaratteristica';
import {NcScheda} from '../../../_models/NcScheda';
import {OrdineGroup} from '../../../_models/OrdineGroup';
import {AuthenticationService} from '../../../_services/authentication.service';
import {NonconformeService} from '../../../_services/nonconforme.service';
import {Contenitore} from '../../../_models/Contenitore';
import {MessageConfirm} from '../../../_helpers/message-confirm.service';
import {QualitaSchedeService} from '../../../_services/qualitaschede.service';
import {TipoRisorsa} from '../../../_models/generated/tipo-risorsa'
import {IonInput} from '@ionic/angular';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-check-controlli-list',
  templateUrl: './check-controlli-list.component.html',
  styleUrls: ['./check-controlli-list.component.scss'],
  standalone: false
})
export class CheckControlliListComponent implements OnInit {
  @ViewChild('valoreInput') valoreInput!: IonInput;
  @Input() ordine: OrdineGroup;
  @Input() rifOdP = '';
  @Input() idDocumento = 0;
  @Input() idRiga = 0;
  @Input() codBox = '';
  @Input() lotto = '';
  @Input() tipoControllo = 0;
  @Input() codArtOrdine = '';
  @Input() codArt = '';
  @Input() numFase = 0;
  @Input() quantitaOdP = 1;
  @Input() quantitaCq = 0;
  @Input() boxesNc: Contenitore[] = [];
  @Output() foundNc = new EventEmitter<NcScheda>();
  @Input() ambito = 1;
  @Input() codCliFor = 0;
  @Input() tipoAnagrafica = 2;
  // Feature 116 (issue #3350): opt-in esplicito, default "non filtrato". I flussi che non lo
  // valorizzano (rientro terzista, ingresso merce da DDT fornitore) restano invariati.
  @Input() filtroRisorsaAttivo = false;
  scheda: CqSchede;
  statoSchede = 0;
  controlli: CqCicloControllo[] = [];
  currControllo: CqCicloControllo;
  currIndex = 0;
  currEsito = 0;
  statoControlli = 1;
  esitoControlli = 1;
  caratteristiche: CqCaratteristica[] = [];
  annotazione = '';
  statoNc = false;
  viewSkipCq = false;
  currSchedaNc: NcScheda = {
    organizzazioneId: 0, idSchedaNC: 0, idTipoSchedaNC: 0, dataUnixRegistrazione: 0,
    codArt: '', statoScheda: 0, tipoNC: 1, tipoProvenienza: 3, qtaNonConforme: 0
  };
  qtaNc = 0;
  loading = false;
  subscriptions: Subscription;
  protected readonly TipoRisorsa = TipoRisorsa

  // Contesto di pertinenza passato alla tendina codici NC (feature 116, issue #3350).
  // Vale 0 — cioè "nessun filtro" — quando il filtro non è abilitato oppure quando l'ordine non
  // porta una risorsa utilizzabile: l'operatore non deve mai restare bloccato da un dato incoerente
  // (US3). `risorsaId` arriva dall'ordine già in memoria, nessuna chiamata HTTP aggiuntiva.
  get risorsaIdFiltro(): number {
    return this.filtroRisorsaAttivo ? (this.ordine?.risorsaId ?? 0) : 0;
  }

  constructor(
    private authService: AuthenticationService,
    private saveMessage: SaveMessage,
    private deleteConfirm: MessageConfirm,
    private organizzazioniService: OrganizzazioniService,
    private nonconformeService: NonconformeService,
    private qualitaSchedeService: QualitaSchedeService,
    private qualitaService: QualitaService) {
    this.subscriptions = this.qualitaSchedeService.lastSchedaUpdated
      .subscribe((scheda: CqSchede) => {
        if (scheda && this.idDocumento === scheda.idDocCollegato && this.idRiga === scheda.idRigaDocCollegato && 
          scheda.idSchedaControllo > 0) {
          this.statoSchede = 3;
          this.scheda = scheda;
          this.getControlli();
          //this.getSchede();
        }
      });
  }

  ngOnInit() {
    this.viewSkipCq = this.organizzazioniService.skipCq;
    this.getSchede();
  }

  getSchede() {
    this.scheda = null;
    if (this.rifOdP == null || this.numFase == null) {
      return false;
    }
    this.loading = true;
    const fase = this.numFase > 0 ? this.numFase : 0;
    this.qualitaSchedeService.getSchedeOfOdP(this.organizzazioniService.organizzazioneId,
      this.rifOdP.substring(0, 13), fase, this.codBox)
      .then((_schede: SearchResult<CqSchede>) => {
        if (_schede.totalCount > 0) {
          this.statoSchede = 3;
          this.scheda = _schede.result[0];
          this.getControlli();
        } else this.statoSchede = 1;
        this.statoControlli = _schede.totalCount > 0 ? 1 : 2;
        this.qualitaService.statoControlli.next(this.statoControlli);
      })
      .finally(() => this.loading = false);
  }

  getControlli() {
    this.controlli = [];
    this.currControllo = null;
    this.currIndex = 0;
    if (this.codArtOrdine == null || this.numFase == null) {
      return false;
    }
    this.loading = true;
    const fase = this.numFase > 0 ? this.numFase : 0;
    this.qualitaService.getControlliOfCodArt(this.organizzazioniService.organizzazioneId,
      this.codArtOrdine, fase, this.ordine?.idDocumento ?? null, this.ordine?.varianteArt)
      .then((_controlli: SearchResult<CqCicloControllo>) => {
        if (_controlli.totalCount > 0) {
          const controlli = _controlli.result.filter((_controllo: CqCicloControllo) => {
            return (this.tipoControllo === 0 ||
              (this.tipoControllo === 1 && _controllo.richiediAdAvvioProd) ||
              (this.tipoControllo === 2 && _controllo.richiediDuranteProd) ||
              (this.tipoControllo === 3 && _controllo.richiediAllaFineProd));
          });
          controlli.forEach((controllo: CqCicloControllo) => {
            const numControlli = controllo.controlloTotale ? this.quantitaOdP : controllo.dimensioneCampione;
            controllo.numCampione = 1;
            controllo.totCampione = numControlli;
            this.controlli.push({...controllo});
            for (let i = 1; i < numControlli; i++) {
              controllo.numCampione = i + 1;
              this.controlli.push({...controllo});
            }
          });
          if (this.controlli.length > 0) {
            this.nextControllo();
          }
        }
        this.statoControlli = this.controlli.length > 0 ? 1 : 2;
        this.qualitaService.statoControlli.next(this.statoControlli);
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei controlli."))
      .finally(() => this.loading = false);
  }

  moveControllo = (step: number) => {
    if (step > 0 && (this.controlli.length - 1) > this.currIndex) {
      this.currIndex += 1;
      this.nextControllo();
    } else if (step < 0 && this.currIndex > 0) {
      this.currIndex -= 1;
      this.nextControllo();
    } else {
      this.statoControlli = 2;
      this.qualitaService.statoControlli.next(this.statoControlli);
    }
  }

  nextControllo = () => {
    this.annotazione = '';
    this.currEsito = 0;
    this.currControllo = this.controlli[this.currIndex];
    this.getCaratteristiche();
  };

  focusValoreInserito = () => {
    // Riporta il focus sul campo "Valore rilevato" solo se il controllo successivo
    // è numerico (tipoCaratteristica === 1) e non siamo nel flusso non conformità.
    if (this.currControllo?.tipoCaratteristica === 1 && !this.statoNc) {
      setTimeout(() => {
        if (this.valoreInput) {
          this.valoreInput.setFocus();
        }
      }, 100);
    }
  };

  createCqSchede() {
    this.statoSchede = 1;
    const cqScheda: CqSchede = {
      organizzazioneId: this.organizzazioniService.organizzazioneId,
      cqSchedaId: 0,
      idSchedaControllo: 0,
      numSchedaControllo: 0,
      dataRegistrazione: new Date(),
      dataUnixRegistrazione: Math.floor(new Date().getTime() / 1000),
      statoScheda: 0,
      ambitoUtilizzo: this.ambito,
      ambito: this.ambito,
      codArt: this.codArt,
      rifLottoAlfanum: '', // rigaOrd.lottoAlfaNum, (SE AGGIUNTO VA IN ERRORE SCHEDA)
      id: this.organizzazioniService.padLeft(this.idDocumento,9)+this.organizzazioniService.padLeft(this.idRiga,4),
      idDocCollegato: this.idDocumento,
      idRigaDocCollegato: this.idRiga,
      //codCliFor: this.codCliFor > 0 ? this.codCliFor : null, // this.codCliFor,
      //tipoAnagrafica: null, // 2, // this.tipoAnagrafica,
      annotazione: this.codBox,
      idCicloControllo: 0
    };
    this.qualitaSchedeService.createSchedaAsync(cqScheda)
      .then(() => this.statoSchede = 2)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione della scheda di controllo qualità."));
  }

  checkControllo = () => {
    this.currEsito = 2;
    if (this.currControllo == null || this.currControllo.valoreInserito == null) {
      return false;
    }
    const valInferiore = this.currControllo.tolleranzaInferiore * (this.currControllo.tolleranzaInferiore > 0 ? -1 : 1);

    if (this.currControllo.valoreInserito >= (this.currControllo.valoreNominale + valInferiore) &&
      this.currControllo.valoreInserito <= (this.currControllo.valoreNominale + this.currControllo.tolleranzaSuperiore)) {
      this.currEsito = 1;
    }
  };

  setControllo = (esito?: number, idValore?: number) => {
    if (esito) {
      this.currEsito = esito;
    }
    if (!this.statoNc) {
      this.createControllo(esito, idValore);
    }
    if (this.currEsito === 2) {
      this.currSchedaNc.qtaNonConforme = this.quantitaCq;
      this.statoNc = true;
      this.esitoControlli = this.currEsito;
      return false;
    }
    this.statoNc = false;
    if ((this.controlli.length - 1) > this.currIndex) {
      this.currIndex += 1;
      this.nextControllo();
      this.focusValoreInserito();
    } else {
      this.statoControlli = 2;
      this.qualitaService.esitoControlli.next(this.esitoControlli);
      this.qualitaService.statoControlli.next(this.statoControlli);
    }
  };

  getCaratteristiche = () => {
    this.caratteristiche = [];
    this.qualitaService.getCaratteristicheById(this.organizzazioniService.organizzazioneId,
      this.currControllo.idCaratteristica)
      .then((_carat: SearchResult<CqCaratteristica>) => {
        if (_carat.totalCount > 0) {
          this.caratteristiche = _carat.result;
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento delle caratteristiche."));
  };

  createControllo = (esito?: number, idValore?: number) => {
    if (this.currControllo.tipoCaratteristica === 1 && esito == null) {
      esito = ((this.currControllo.valoreInserito > (this.currControllo.valoreNominale + this.currControllo.tolleranzaInferiore)) &&
        (this.currControllo.valoreInserito > (this.currControllo.valoreNominale + this.currControllo.tolleranzaInferiore))) ? 1 : 2;
    }
    const idDoc = this.qualitaService.getIdOrdine(this.rifOdP);
    const dataEvento = parseInt((new Date().getTime() / 1000).toString(), 10);
    const newControllo: ControlloQualita = {
      organizzazioneId: this.organizzazioniService.organizzazioneId,
      idSchedaControllo: this.scheda ? this.scheda.idSchedaControllo : 0,
      idRigaCicloControllo: this.currControllo.idRigaCicloControllo,
      controlloId: 0,
      ambitoUtilizzo: this.currControllo.ambitoUtilizzo,
      dataUnixRegistrazione: dataEvento,
      codArt: this.currControllo.codArt,
      unitaMisura: this.currControllo.unitaMisura,
      idCaratteristica: this.currControllo.idCaratteristica,
      numCampione: this.currControllo.numCampione,
      numProgrCaratt: this.currControllo.numProgrCaratt,
      valoreRiscontrato: this.currControllo.valoreInserito,
      esitoControllo: this.currControllo.tipoCaratteristica > 1 ? esito : 0,
      idValoreAmmesso: this.currControllo.tipoCaratteristica > 1 ? idValore : 0,
      esitoForzato: this.currControllo.tipoCaratteristica > 1 ? 1 : 0,
      desRigaSchedaContr: this.currControllo.descrFaseCicloContr,
      annotazione: (this.lotto ? ` Lotto ${this.lotto} ` : '') + (this.codBox ? ` Box ${this.codBox} ` : '') + this.annotazione,
      risorsaControllo: this.currControllo.codRisorsaStrumMis ?? '',
      idDocumento: idDoc.idDocumento,
      idRiga: idDoc.idRiga,
      rifEsterno: this.ordine ? this.ordine.rifEsterno : ''
    };
    this.qualitaService.createControlloAsync(newControllo)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il salvataggio del controllo."));
  };

  confirmCreateSchedaNc = () => {
    this.deleteConfirm
      .presentAlert(`Sei sicuro di voler procedere con creazione scheda NC?`, () => {
        this.createSchedaNc();
      });
  };

  createSchedaNc = () => {
    this.currEsito = 0;
    this.loading = true;
    // const dataEvento = parseInt((new Date().getTime() / 1000).toString(), 10);
    const idDoc = this.qualitaService.getIdOrdine(this.rifOdP);
    this.currSchedaNc.dataUnixRegistrazione = parseInt((new Date().getTime() / 1000).toString(), 10);
    this.currSchedaNc.codArt = this.codArt; //this.tipoControllo === 1 ? this.codMateriale : this.currControllo.codArt;
    this.currSchedaNc.organizzazioneId = this.organizzazioniService.organizzazioneId;
    this.currSchedaNc.idSchedaControllo = this.scheda ? this.scheda.idSchedaControllo : 0;
    this.currSchedaNc.idRigaCicloControllo = this.currControllo.idRigaCicloControllo;
    this.currSchedaNc.idDocumento = idDoc.idDocumento;
    this.currSchedaNc.idRiga = idDoc.idRiga;
    this.currSchedaNc.rifLottoAlfanum = this.lotto;
    this.currSchedaNc.rifEsterno = this.ordine ? this.ordine.rifEsterno : '';
    this.currSchedaNc.codReparto = (this.ordine && this.ordine.risorsa) ? this.ordine.risorsa.reparto : '';
    if (this.boxesNc && this.boxesNc.length > 0) {
      this.currSchedaNc.annotazioneScheda += ' Box: ';
      this.boxesNc.forEach((_box: Contenitore) =>
        this.currSchedaNc.annotazioneScheda += ' ' + _box.codice + ' ID Mat.' + _box.codLottoOrigine);
    }
    this.nonconformeService
      .createNcSchedaAsync(this.currSchedaNc)
      /*.sendNcSchedaAsync(this.organizzazioniService.organizzazioneId, dataEvento, this.ordine,
        this.currSchedaNc, this.authService.currentUserValue.email)*/
      .then(() => {
        this.currSchedaNc = {
          organizzazioneId: this.organizzazioniService.organizzazioneId,
          idSchedaNC: 0, idTipoSchedaNC: 0, dataUnixRegistrazione: 0,
          codArt: '', statoScheda: 0, tipoNC: 1, tipoProvenienza: 3, qtaNonConforme: 0
        };
        this.setControllo();
        this.foundNc.emit(this.currSchedaNc);
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione della scheda NC."))
      .finally(() => this.loading = false);
  };
}
